import { redirectToGrowXLogout } from "../loginservice/redirectToGrowXLogout";

export let logoutHandler: (() => void) | null = null;

export const registerLogout = (fn: () => void) => {
  logoutHandler = fn;
};

export const executeLogout = () => {
  setTimeout(redirectToGrowXLogout, 0);
  logoutHandler?.();
};
